document.addEventListener('DOMContentLoaded', () => {
  const helps = document.querySelectorAll('.toggle-help');
  if (helps.length === 0) {
    return;
  }

  helps.forEach(help => {
    help.addEventListener('click', () => {
      const id = help.getAttribute('id');
      if (id) {
        const name = id.replace('toggle-help-on-', '');
        const help_block = document.querySelector('#help-on-' + name);

        if (help_block != null) {
          if ((help_block as HTMLElement).style.display == 'none') {
            (help_block as HTMLElement).style.display = 'block';
          } else {
            (help_block as HTMLElement).style.display = 'none';
          }
        }
      }
    });
  });
});
